import { Card, CheckmarkIcon, Row, Title } from 'internalLibrary';
import { FC } from 'react';
import { PhoneCallingIcon } from 'assets';
import { useTranslation } from 'react-i18next';
import layout from '../../../../scss/layout.module.scss';
import LoanApplicationProcessLayout from 'ui/components/LoanApplicationProcessLayout';
import style from './PendingManual.module.scss';

const PendingManualScene: FC = () => {
  const { t } = useTranslation();

  return (
    <LoanApplicationProcessLayout>
      <Title
        icon={<CheckmarkIcon />}
        text={t('approvedManual_title')}
        className={style.title}
      />
      <div className={layout['width-lg']}>
        <Card className={style.card}>
          <Card intent="success" className={style['inner-card']}>
            <Row className={style.row}>
              <PhoneCallingIcon className={style.phoneIcon} />
              <span className={style['card-main-text']}>
                {t('approvedManual_card_top')}
              </span>
            </Row>
            <span className={style['card-bottom-text']}>
              {t('approvedManual_card_bottom')}
            </span>
          </Card>
        </Card>
      </div>
    </LoanApplicationProcessLayout>
  );
};

export default PendingManualScene;
